import {combineReducers} from 'redux';

import create from './suborg-create/reducer';
import index from './suborgs-index/reducer';
import move from './suborg-move/reducer';

export default combineReducers({index, create, move});
